export default {
  baseUrl: process.env.REACT_APP_INTERCOM_BASE_URL || ''
}
